import * as t from './actionTypes';

export function createOrganizationError(error: string) {
  return {
    type: t.CREATE_ORGANIZATION_ERROR,
    error,
  };
}
